import { BOARD_ID_PRIORITY } from '@shared/constants';
import { AudioContext } from '@shared/contexts/AudioContext';
import { BoardContext } from '@shared/contexts/BoardContext';
import useFeatures from '@shared/hooks/useFeatures';
import { ManuallyTriggeredAudioHandler } from '@shared/models/manuallyTriggeredAudioHandler';
import { useContext, useEffect } from 'react';

export default function useManuallyTriggeredAudio(
  priority: number,
  play: () => Promise<void>,
) {
  const audio = useContext(AudioContext);
  const boardContext = useContext(BoardContext);
  const { manualAudio } = useFeatures();
  useEffect(() => {
    if (!manualAudio) {
      return;
    }

    const manualTriggeredAudioHandler: ManuallyTriggeredAudioHandler = {
      priority: priority + boardContext.id * BOARD_ID_PRIORITY,
      play,
    };
    audio.registerManualHandler(manualTriggeredAudioHandler);
    return () => {
      audio.unregisterManualHandler(manualTriggeredAudioHandler);
    };
  }, [priority, audio, play, boardContext.id, manualAudio]);
}
